<template>
  <UiDialog
    class="restore-cart"
    name="restore-cart"
    dialog-type="modal"
    @close="closeDialog()"
  >
    <template #dialogHeader>
      <IconShoppingcart class="icon icon--mini-cart" />
      <strong
        class="dialog__title"
        v-text="$t('Cart not active')"
      />
    </template>

    <div>{{ $t('Cart not active explanation') }}</div>

    <div class="added-to-cart__product-buttons">
      <button
        class="button button--full"
        :disabled="loading"
        @click.prevent="proceed()"
      >
        <span>{{ $t('Proceed') }}</span>
      </button>

      <button
        class="button button--full"
        :disabled="loading"
        @click.prevent="restore()"
      >
        <span>{{ $t('Restore cart') }}</span>
      </button>
    </div>
  </UiDialog>
</template>

<script lang="ts" setup>
const { inactive, createEmptyCart, restoreCart, getCart, cartStatus, placedOrderForQuoteCookie, getCartId } = useCart()
const router = useRouter()
const restoreCartDialog = useUiDialog('restore-cart')
const status = ref()
const restored = ref()
const loading = ref<boolean>(false)

watch(inactive, async (newVal) => {
  if (!newVal) {
    return
  }

  status.value = await cartStatus(placedOrderForQuoteCookie.value || getCartId.value)
  if (status.value.group === 'restore') {
    restoreCartDialog.open()
  }
})

const proceed = async () => {
  loading.value = true
  await createEmptyCart()
  restoreCartDialog.close()
  placedOrderForQuoteCookie.value = null
  await router.replace('/')
}

const closeDialog = async () => {
  if (!restored.value && !loading.value) {
    await createEmptyCart()
    await router.replace('/')
  }
}

const restore = async () => {
  loading.value = true
  restored.value = await restoreCart(placedOrderForQuoteCookie.value || getCartId.value || '')
  if (restored.value) {
    await getCart({ force: true })
    placedOrderForQuoteCookie.value = null
    restoreCartDialog.close()
  }
  else {
    await proceed()
  }
}
</script>

<style>
@import url("~layers/app/components/Cart/Restore.css");
</style>
